export default __webpack_public_path__ + "static/media/LocationDb.c24c4f9c.svg";